/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Workout',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M17.87 6.462c.732-.142 1.423.415 1.423 1.16a1.16 1.16 0 0 1-1.001 1.15l-4.099.572c-.146.02-.255.145-.255.293v3.08c0 .026.003.052.01.077l2.078 7.746a1.15 1.15 0 1 1-2.222.595l-1.514-5.641c-.078-.292-.493-.292-.572 0l-1.512 5.64a1.15 1.15 0 1 1-2.222-.595l2.066-7.702c.007-.025.01-.051.01-.077V9.637c0-.148-.109-.273-.255-.293l-4.098-.572a1.16 1.16 0 0 1-1.001-1.15c0-.745.691-1.302 1.423-1.16 1.551.301 4.054.723 5.87.723s4.319-.422 5.87-.723zM12 2.013c1.174 0 2.125.951 2.125 2.125S13.174 6.263 12 6.263s-2.125-.951-2.125-2.125.951-2.125 2.125-2.125z" />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
